module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"backup\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  sort-event=\"$ctrl.sortEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Backups\"\n  resource=\"Backup\"\n  transformer=\"BackupsTransforms\"\n  no-items-text=\"No Backups Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/backups/backups.html
// module id = 1773
// module chunks = 0